var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header',{attrs:{"title":"설문조사","showTitle":true,"showCart":false,"showHome":true,"showBack":true}}),_vm._v(" "),_c('main',{staticClass:"benefit stamp stamp-card"},[_c('SurveyTab'),_vm._v(" "),_c('SurveyList')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42fbfb9a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey/SurveyMain.vue
// module id = null
// module chunks = 